import './bootstrap';

// Externals
import 'perfect-scrollbar/dist/js/perfect-scrollbar.jquery';
import '@/externals/waves';
import 'sticky-kit/dist/sticky-kit';
import 'jquery-sparkline';
import '@/externals/template';

// Base
import '@wielink-application/shared/js/vue.js'